const setStorageItem = (key: string, value: any) => {
    const parsedValue = JSON.stringify(value);

    sessionStorage.setItem(key, parsedValue);
}

const getStorageItem = (key: string) => {
    const storedItem = sessionStorage.getItem(key);

    if (storedItem) {
        return JSON.parse(storedItem);
    }
}

const deleteStorageItem = (key: string) => {
    sessionStorage.removeItem(key);
}

export const sessionStorageHelper = {
    setStorageItem,
    getStorageItem,
    deleteStorageItem
}